import { ROLES } from "@/content";
import { ArrowUpRight, Mail } from "lucide-react";

const RoleMark = ({ role }) => {
  if (role.logo) {
    return (
      <div className={`${role.wideLogo ? "w-24 sm:w-28" : "w-16 sm:w-20"} h-16 sm:h-20 shrink-0 bg-white border border-ink/15 flex items-center justify-center overflow-hidden ${role.fullBleed ? "" : "p-2"}`}>
        <img src={role.logo} alt={`${role.name.en} logo`} className={role.fullBleed ? "w-full h-full object-cover" : "max-w-full max-h-full object-contain"} loading="lazy" />
      </div>
    );
  }
  return (
    <div className="w-16 h-16 sm:w-20 sm:h-20 shrink-0 border border-brass flex items-center justify-center" aria-hidden="true">
      {role.monogram ? (
        <span className="latin text-2xl text-brass">{role.monogram}</span>
      ) : (
        <svg width="40" height="40" viewBox="0 0 40 40"><circle cx="14" cy="20" r="9" fill="none" stroke="#8a5a2b" /><circle cx="26" cy="20" r="9" fill="none" stroke="#8a5a2b" /></svg>
      )}
    </div>
  );
};

const RoleCard = ({ role, lang, t }) => (
  <article className="flex gap-4 sm:gap-6 py-8 border-t border-ink/20" data-testid={`role-card-${role.id}`}>
    <RoleMark role={role} />
    <div className="min-w-0">
      <p className="lb text-brassink">{role.title[lang]}</p>
      <h3 className="dd text-2xl mt-1 leading-tight">{role.name[lang]}</h3>
      {role.domain && (
        <div className="sv text-sm mt-3 flex flex-wrap gap-x-5 gap-y-2" dir="ltr">
          <a href={role.url || `https://${role.domain}`} target="_blank" rel="noopener noreferrer" aria-label={`${t.visit}: ${role.domain}`}
            className="inline-flex items-center gap-1 border-b border-ink/30 transition-colors duration-200 hover:text-brass hover:border-brass"
            data-testid={`role-website-${role.id}`}>
            {role.domain} <ArrowUpRight size={14} />
          </a>
          <a href={`mailto:Jamal@${role.domain}`}
            className="inline-flex items-center gap-1.5 border-b border-ink/30 transition-colors duration-200 hover:text-brass hover:border-brass"
            data-testid={`role-email-${role.id}`}>
            <Mail size={14} /> Jamal@{role.domain}
          </a>
        </div>
      )}
    </div>
  </article>
);

export const Roles = ({ t, lang }) => (
  <section id="roles" className="bg-paper2 py-24 md:py-32" data-testid="roles-section">
    <div className="max-w-6xl mx-auto px-6">
      <h2 className="dd reveal">{t.rolesTitle}</h2>
      <p className="sv mt-4 text-[17px] text-ink2 max-w-xl">{t.rolesIntro}</p>
      <div className="st mt-12 grid md:grid-cols-2 gap-x-12">
        {ROLES.map((r) => <RoleCard key={r.id} role={r} lang={lang} t={t} />)}
      </div>
    </div>
  </section>
);
